module.exports = __webpack_public_path__ + "static/media/close-icon.ecf70e0c.svg";